import React from 'react';
export function RegenerativeSection() {
  return <section className="relative py-24 md:py-32 bg-brand-alt clip-diagonal-top mt-12 md:mt-20" data-id="element-151">
      <div className="container px-4 md:px-6 relative z-10 pt-8 md:pt-16" data-id="element-152">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-153">
          {/* Image/Visual Side */}
          <div className="order-2 lg:order-1 relative" data-id="element-154">
            <div className="aspect-[4/5] md:aspect-square lg:aspect-[4/5] bg-brand-divider rounded-sm overflow-hidden relative" data-id="element-155">
              <img src="https://cdn.magicpatterns.com/uploads/fQU2u9SncsGfdzi9ivtXmF/bbl-be-clinical-2.jpg" alt="Be Clinical BBL treatment specialist" className="w-full h-full object-cover opacity-90" data-id="element-156" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-sage/10 rounded-full blur-2xl" data-id="element-157"></div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2" data-id="element-158">
            <p className="font-sans text-brand-gold font-bold tracking-[0.2em] uppercase text-xs md:text-sm mb-6" data-id="element-159">
              Science Meets Natural Beauty
            </p>
            <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-brand-text leading-[1.2] mb-8" data-id="element-160">
              We don't cover your skin tone. We restore it.
            </h2>
            <p className="font-sans text-brand-text/80 text-base md:text-lg leading-relaxed mb-10" data-id="element-161">
              BBL delivers precise wavelengths of light targeting pigmentation,
              broken capillaries, and early signs of aging — while triggering a
              regenerative response at the cellular level. Stanford research
              shows BBL actually changes the expression of aging-related genes.
              Your skin doesn't just look younger. It behaves younger.
            </p>

            <div className="flex flex-wrap gap-3" data-id="element-162">
              {['Light-Based', 'Zero Injectables', 'Cellular Regeneration'].map((badge, i) => <span key={i} className="inline-flex items-center px-4 py-2 rounded-full border border-brand-sage/30 bg-brand-sage/5 text-brand-sage font-sans text-sm font-medium" data-id="element-163">
                    {badge}
                  </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}